export const Collabs = () => {
    return (
        <div className="generic_page">
            MAX MORTON
        </div>
    )
}